const DELIVERY_METHODS = [
  { value: "delivery", label: "Delivery" },
  { value: "collection", label: "Collection from Coleraine" },
  { value: "not_sure", label: "Not sure yet" },
];

const fieldBase =
  "w-full bg-transparent border-b border-brand-border focus:border-brand-gold text-brand-text py-3 outline-none transition-colors duration-300 placeholder:text-brand-text-secondary/30 text-[14px]";

function FieldLabel({ text, required }) {
  return (
    <label className="block text-[11px] tracking-wide uppercase text-brand-text-secondary/70 mb-2">
      {text}
      {required && <span className="text-brand-gold ml-0.5">*</span>}
    </label>
  );
}

/**
 * Delivery method picker + conditionally-rendered address fields.
 * Controlled by parent `form` state via `onUpdate(field)(event)` and `onSetMethod(value)`.
 */
export default function QuoteDeliverySection({ form, onUpdate, onSetMethod }) {
  return (
    <>
      <div className="flex flex-wrap gap-2" data-testid="delivery-method-selector">
        {DELIVERY_METHODS.map((m) => {
          const active = form.delivery_method === m.value;
          const cls = active
            ? "border-brand-gold text-brand-gold bg-brand-gold/5"
            : "border-brand-border text-brand-text-secondary hover:border-brand-text-secondary/40";
          return (
            <button
              key={m.value}
              type="button"
              onClick={() => onSetMethod(m.value)}
              className={`px-5 py-2.5 rounded-sm text-[13px] font-medium transition-[border-color,color,background-color] duration-200 border ${cls}`}
              data-testid={`delivery-${m.value}`}
            >
              {m.label}
            </button>
          );
        })}
      </div>

      {form.delivery_method === "delivery" && (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-7" data-testid="address-fields">
          <div className="md:col-span-2">
            <FieldLabel text="Address Line 1" required />
            <input
              type="text"
              required
              value={form.address_line_1}
              onChange={onUpdate("address_line_1")}
              className={fieldBase}
              placeholder="Street address"
              data-testid="quote-address-1"
            />
          </div>
          <div className="md:col-span-2">
            <FieldLabel text="Address Line 2" />
            <input
              type="text"
              value={form.address_line_2}
              onChange={onUpdate("address_line_2")}
              className={fieldBase}
              placeholder="Flat, building, floor (optional)"
              data-testid="quote-address-2"
            />
          </div>
          <div>
            <FieldLabel text="City / Town" required />
            <input
              type="text"
              required
              value={form.city}
              onChange={onUpdate("city")}
              className={fieldBase}
              placeholder="e.g. Belfast"
              data-testid="quote-city"
            />
          </div>
          <div>
            <FieldLabel text="Postcode" required />
            <input
              type="text"
              required
              value={form.postcode}
              onChange={onUpdate("postcode")}
              className={fieldBase}
              placeholder="e.g. BT52 1AA"
              data-testid="quote-postcode"
            />
          </div>
          <div className="md:col-span-2">
            <FieldLabel text="Country" />
            <input
              type="text"
              value={form.country}
              onChange={onUpdate("country")}
              className={fieldBase}
              data-testid="quote-country"
            />
          </div>
        </div>
      )}

      {form.delivery_method === "collection" && (
        <p className="mt-4 text-[13px] text-brand-text-secondary/60" data-testid="collection-note">
          You can collect your order from our Coleraine location. We&rsquo;ll confirm the pickup details in your quote.
        </p>
      )}
    </>
  );
}
